import { FileExcelOutlined, FilePdfOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Dropdown, Input, Menu, Pagination, Popconfirm, Row, Space, Table, Tooltip, message } from 'antd';
import dayjs from 'dayjs';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useEffect, useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as ViewIcon } from '../../Images/ViewIcon.svg';
import { deleteVendor, fetchVendorList, resetVendorList } from '../../slices/vendor';
import ImportDataModal from '../../Common/ImportDataModal';
import moment from 'moment';
import { debounce } from 'lodash';
import { createActivityLog } from '../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import logo from '../../Images/alux-logo.png';
import formatFile from "../../Images/sample-files/vendor-format.xlsx";
export default function VendorList() {
  let navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'vendor_registered_name',
    'address1',
    'address2',
    'person_name',
    'phone',
    'email',
    'vendor_trade_name',
    'vendor_code_as_per_company_erp',
    'designation',
    'action',
  ]);
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const { data = [], totalRecord, status } = useSelector((state) => state.vendor);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [search, setSearch] = useState(localStorage.getItem('die_text_search_vendor') || '');
  const [openModal, setOpenModal] = useState(false);
  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  useEffect(() => {
    dispatch(resetVendorList());
    dispatch(fetchVendorList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
  }, [page, pagesize, search, orderBy, dispatch]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    debouncedAPICall(value)
    setSearch(value);
    localStorage.setItem('die_text_search_vendor', value);
  };
  const debouncedAPICall = useMemo(() =>
    debounce((query) => {
      if (query.length >= 3) {
        dispatch(fetchVendorList({ search: query }));
        localStorage.setItem('die_text_search_vendor', query);
      }
    }, 50), [dispatch]
  );
  useEffect(() => {
    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);


  const resetFilter = () => {
    setSearch('');
    setOrderBy(null);
    localStorage.removeItem('die_text_search_vendor');
    localStorage.removeItem('die_group_search_vendor');
    dispatch(fetchVendorList({ page: 1, pagesize }));
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "udyam_aadhaar_no" && sortOrder === "ascend") {
      sortingEnumKey = "udyam_aadhaar_no";
    }
    if (sortField === "udyam_aadhaar_no" && sortOrder === "descend") {
      sortingEnumKey = "-udyam_aadhaar_no";
    }
    if (sortField === "vendor_trade_name" && sortOrder === "ascend") {
      sortingEnumKey = "vendor_trade_name";
    }
    if (sortField === "vendor_trade_name" && sortOrder === "descend") {
      sortingEnumKey = "-vendor_trade_name";
    }
    if (sortField === "vendor_code_as_per_company_erp" && sortOrder === "ascend") {
      sortingEnumKey = "vendor_code_as_per_company_erp";
    }
    if (sortField === "vendor_code_as_per_company_erp" && sortOrder === "descend") {
      sortingEnumKey = "-vendor_code_as_per_company_erp";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "designation" && sortOrder === "ascend") {
      sortingEnumKey = "designation";
    }
    if (sortField === "designation" && sortOrder === "descend") {
      sortingEnumKey = "-designation";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }

    if (sortField === "gst_no" && sortOrder === "ascend") {
      sortingEnumKey = "gst_no";
    }
    if (sortField === "gst_no" && sortOrder === "descend") {
      sortingEnumKey = "-gst_no";
    }
    if (sortField === "vendor_registered_name" && sortOrder === "ascend") {
      sortingEnumKey = "vendor_registered_name";
    }
    if (sortField === "vendor_registered_name" && sortOrder === "descend") {
      sortingEnumKey = "-vendor_registered_name";
    }


    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }
    return sortingEnumKey;
  };
  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1,
  }));
   const refreshTable = () => {
      dispatch(resetVendorList());
      dispatch(
        fetchVendorList({
          page: 1,
          pagesize,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        })
      );
    };
  
  const handleEdit = (data) => {
    navigate(`/edit-vendor/${data.id}`);
  };
  const handleDelete = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteVendor(id))
      .unwrap()
      .then(() => {
        message.success('Vendor Archive Successfully!');
        dispatch(fetchVendorList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
      })
      .catch((error) => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 80,
    },
    {
      title: 'Legal Name of Business',
      dataIndex: 'vendor_registered_name',
      key: 'vendor_registered_name',
      render: (text) => text ? text : 'N/A',
      sorter: true,
      width: 150,
    },
    {
      title: 'GST Number',
      dataIndex: 'gst_no',
      key: 'gst_no',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Aadhar No',
      dataIndex: 'udyam_aadhaar_no',
      key: 'udyam_aadhaar_no',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Vendor Trade Name',
      dataIndex: 'vendor_trade_name',
      key: 'vendor_trade_name',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Vendor Code',
      dataIndex: 'vendor_code_as_per_company_erp',
      key: 'vendor_code_as_per_company_erp',
      sorter: true,
      width: 150,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Person Name',
      dataIndex: 'person_name',
      key: 'person_name',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: 'Contact Number',
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
      sorter: true,
      render: (record) => {
        return (
          <span>+{record} </span>
        )
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150,
      sorter: true,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: "Registered Business Address",
      dataIndex: "address1",
      key: "address1",
      width: 200,
      sorter: false,
      render: (text, record) => {
        const address = `${record?.registered_business_address_area || ""} 
                        ${record?.registered_business_address_building || ""} 
                        ${record?.registered_business_address_landmark || ""} 
                        ${record?.registered_business_address_city || ""} 
                        ${record?.registered_business_address_state || ""} 
                        ${record?.registered_business_address_country || ""}- 
                        ${record?.registered_business_address_pincode || ""}`
          .trim()
          .toUpperCase(); // Convert full address to uppercase

        return <span>{address ? address : "N/A"}</span>;
      },
    },
    {
      title: "Trading Address",
      dataIndex: "address2",
      key: "address2",
      sorter: false,
      width: 200,
      render: (text, record) => {
        const address = `${record?.trading_address_area || ""} 
                        ${record?.trading_address_building || ""} 
                        ${record?.trading_address_landmark || ""} 
                        ${record?.trading_address_city || ""} 
                        ${record?.trading_address_state || ""} 
                        ${record?.trading_address_country || ""}- 
                        ${record?.trading_address_pincode || ""}`
          .trim()
          .toUpperCase(); // Convert full address to uppercase

        return <span>{address ? address : "N/A"}</span>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'}</span>
        )
      }
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      render: (record) => {
        return (
          <span>{record && record.trim() ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}</span>
        );
      }
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'}</span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (record) => (
        <Space>
          {currentUser.permissions.permissions.vendor.includes("view_vendor") && (
            <Tooltip placement="top" title={"View"}>
              <span style={{ cursor: 'pointer' }}>
                <Link to={`/view-vendor/${record.id}`}>
                  <ViewIcon />
                </Link>
              </span>
            </Tooltip>
          )}
          {currentUser.permissions.permissions.vendor.includes("change_vendor") && (
            <Tooltip placement="top" title={"Edit"}>
              <span onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }}>
                <EditIcon />
              </span>
            </Tooltip>
          )}
          {currentUser.permissions.permissions.vendor.includes("delete_vendor") && (
            <Tooltip placement="top" title={"Archive"}>
              <Popconfirm
                title="Are you sure you want to archive this record?"
                onConfirm={() => handleDelete(record.id)}
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <Archive style={{ cursor: 'pointer' }} />
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group value={checkedList} onChange={handleColumnVisibilityChange}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="vendor_registered_name">Legal Name of Business</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gst_no">GST Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="udyam_aadhaar_no">Aadhar No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="vendor_trade_name">Vendor Trade Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="vendor_code_as_per_company_erp">Vendor Code</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="designation">Designation</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="address1">Registered
                Business
                Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="address2">Trading
                Address</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="person_name">Person Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="phone">Contact</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="email">Email</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12} >
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>Action</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const exportPDF = () => {
    const pdf = new jsPDF("l", "pt", "a4");

    const pdfColumns = [
      { header: 'Sr No.', dataKey: 'SrNo' },
      { header: 'Legal Name Of Buisness', dataKey: 'vendor_registered_name' },
      { header: 'GSTIN', dataKey: 'gst_no' },
      { header: 'Addhar Number', dataKey: 'udyam_aadhaar_no' },
      { header: 'Vender Code', dataKey: 'vendor_code_as_per_company_erp' },
      { header: 'Vendor Trade Name', dataKey: 'vendor_trade_name' },
      { header: 'Person Name', dataKey: 'person_name' },
      { header: 'Designation', dataKey: 'designation' },
      { header: 'Contact Number', dataKey: 'phone' },
      { header: 'Registered Business Address', dataKey: 'address1' },
      { header: 'Trading Address', dataKey: 'address2' },
      { header: 'Email', dataKey: 'email' },
      { header: 'Bank Name', dataKey: 'bank_name' },
      { header: 'Account Number', dataKey: 'bank_account_number' },
      { header: 'Created At', dataKey: 'created_at' },
      { header: 'Created By', dataKey: 'created_by' },
      { header: 'Updated At', dataKey: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by' },
    ];

    const pdfFilteredColumns = pdfColumns.filter(column =>
      checkedList.includes(column.dataKey)
    );

    const rows = data.map((item, index) => {
      const firstBankDetail = item.bankdetails?.[0] || {};
      return {
        SrNo: index + 1,
        vendor_registered_name: item.vendor_registered_name || 'N/A',
        gst_no: item.gst_no || 'N/A',
        udyam_aadhaar_no: item.udyam_aadhaar_no || 'N/A',
        vendor_code_as_per_company_erp: item.vendor_code_as_per_company_erp || 'N/A',
        vendor_trade_name: item.vendor_trade_name || 'N/A',
        person_name: item.person_name || 'N/A',
        designation: item.designation || 'N/A',
        phone: `+${item.phone}` || 'N/A',
        address1: `${item.registered_business_address_building || ''} ${item.registered_business_address_area || ''} ${item.registered_business_address_landmark || ''} ${item.registered_business_address_city || ''} ${item.registered_business_address_state || ''} - ${item.registered_business_address_pincode || ''}`.trim() || 'N/A',
        address2: `${item.trading_address_building || ''} ${item.trading_address_area || ''} ${item.trading_address_landmark || ''} ${item.trading_address_city || ''} ${item.trading_address_state || ''} - ${item.trading_address_pincode || ''}`.trim() || 'N/A',
        email: item.email || 'N/A',
        bank_name: firstBankDetail.bank_name || 'N/A',
        bank_account_number: firstBankDetail.bank_account_number || 'N/A',
        created_at: item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : 'N/A',
        created_by: item.created_by ? `${item.created_by.first_name} ${item.created_by.last_name}` : 'N/A',
        updated_at: item.updated_at ? moment(item.updated_at).format('DD-MM-YYYY') : 'N/A',
        updated_by: item.updated_by ? `${item.updated_by.first_name} ${item.updated_by.last_name}` : 'N/A',
      };
    });

    const pageWidth = pdf.internal.pageSize.width;

    pdf.setFont("times", "bold");
    pdf.setFontSize(16);
    const headingText = "Vendor List";
    const headingX = pageWidth / 2 - pdf.getTextWidth(headingText) / 2;
    pdf.text(headingText, headingX, 40);

    pdf.addImage(logo, "PNG", pageWidth - 100, 10, 90, 30);

    pdf.autoTable({
      columns: pdfFilteredColumns,
      body: rows,
      startY: 80,
      theme: "grid",
      margin: { top: 80, right: 30, left: 30, bottom: 40 },
      styles: {
        font: "times",
        halign: "center",
        overflow: 'linebreak',
        cellWidth: 'auto',
        cellPadding: 3.8,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0]
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false
      },
      didDrawPage: (data) => {
        const pageCount = pdf.internal.getNumberOfPages();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const pageWidth = pdf.internal.pageSize.getWidth();
        pdf.setFontSize(8);
        pdf.text(`Generated on: ${moment().format("DD-MM-YYYY HH:mm:ss")}`, 30, pageHeight - 20);
        const pageNumber = `Page ${pdf.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`;
        pdf.text(pageNumber, pageWidth - 60, pageHeight - 20);
      },
      pageBreak: 'auto',
    });

    pdf.save(`vendor${new Date().toISOString().split('T')[0]}.pdf`);

    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Vendors',
        ip_address: ipAddress,
        discription: 'Vendors pdf download successfully!',
      }),
    );
  };



  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Vendors',
        ip_address: ipAddress,
        discription: 'Vendors excel download successfully!',
      }),
    );
  }
  const csvheaders = [
    { label: 'Sr No.', key: 'SrNo' },
    { label: 'Legal Name Of Business', key: 'vendor_registered_name' },
    { label: 'GSTIN', key: 'gst_no' },
    { label: 'Aadhaar Number', key: 'udyam_aadhaar_no' },
    { label: 'Vendor Code', key: 'vendor_code_as_per_company_erp' },
    { label: 'Vendor Trade Name', key: 'vendor_trade_name' },
    { label: 'Person Name', key: 'person_name' },
    { label: 'Designation', key: 'designation' },
    { label: 'Contact Number', key: 'phone' },
    { label: 'Registered Business Address', key: 'address1' },
    { label: 'Trading Address', key: 'address2' },
    { label: 'Email', key: 'email' },
    { label: 'Bank Name', key: 'bank_name' },
    { label: 'Account Number', key: 'bank_account_number' },
    { label: 'IFSC Code', key: 'bank_ifsc_code' },
    { label: 'Branch Address', key: 'branch_address' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];
  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key)
  );

  const csvListData = data.map((item, index) => {
    const firstBankDetail = item.bankdetails?.[0] || {};
    return {
      SrNo: index + 1,
      vendor_registered_name: item.vendor_registered_name || 'N/A',
      gst_no: item.gst_no || 'N/A',
      udyam_aadhaar_no: item.udyam_aadhaar_no || 'N/A',
      vendor_code_as_per_company_erp: item.vendor_code_as_per_company_erp || 'N/A',
      vendor_trade_name: item.vendor_trade_name || 'N/A',
      person_name: item.person_name || 'N/A',
      designation: item.designation || 'N/A',
      phone: `+${item.phone}` || 'N/A',
      address1: `${item.registered_business_address_building || ''} ${item.registered_business_address_area || ''} ${item.registered_business_address_landmark || ''} ${item.registered_business_address_city || ''} ${item.registered_business_address_state || ''} - ${item.registered_business_address_pincode || ''}`.trim() || 'N/A',
      address2: `${item.trading_address_building || ''} ${item.trading_address_area || ''} ${item.trading_address_landmark || ''} ${item.trading_address_city || ''} ${item.trading_address_state || ''} - ${item.trading_address_pincode || ''}`.trim() || 'N/A',
      email: item.email || 'N/A',
      bank_name: firstBankDetail.bank_name || 'N/A',
      bank_account_number: firstBankDetail.bank_account_number || 'N/A',
      bank_ifsc_code: firstBankDetail.bank_ifsc_code || 'N/A',
      branch_address: firstBankDetail.branch_address || 'N/A',
      created_at: item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : 'N/A',
      created_by: item.created_by ? `${item.created_by.first_name} ${item.created_by.last_name}` : 'N/A',
      updated_at: item.updated_at ? moment(item.updated_at).format('DD-MM-YYYY') : 'N/A',
      updated_by: item.updated_by ? `${item.updated_by.first_name} ${item.updated_by.last_name}` : 'N/A',
    }
  })

  return (
    <div className='mainwrap'>
      <div className='sticyaction'>
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Vendors</h2>
            <div className="bredcrumbwrp">
              <Link to="/die-profilelist" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                 // { title: <Link to="/die-profilelist">Profiles</Link> },
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Vendors' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                onChange={handleSearch}
                style={{ width: 200 }}
              />
              <Tooltip placement="top" title="Reset Filter">
                <Button type="primary" disabled={!search && !orderBy} className='iconlink' onClick={resetFilter}>
                  <FilterIcon />
                </Button>
              </Tooltip>
              {currentUser.permissions.permissions.vendor.includes('download_vendor_excel_copy') && (
                <Tooltip placement="top" title={'Export Excel'} onClick={activityLog}>
                  <Button type="primary" className='iconlink' style={{ width: '10px' }} >
                    <CSVLink filename={"Vendor.csv"} data={csvListData} className='iconlink' headers={csvFilterheaders} >
                      <FileExcelOutlined />
                    </CSVLink>
                  </Button>
                </Tooltip>
              )}
              {currentUser.permissions.permissions.vendor.includes('download_vendor_pdf_copy') && (
                <Tooltip placement="top" title={'Export PDF'}>
                  <Button type="primary" className='iconlink' onClick={exportPDF}>
                    <FilePdfOutlined />
                  </Button>
                </Tooltip>
              )}
              {currentUser.permissions.permissions.vendor.includes("add_vendor") && (
                <Link to="/add-vendor">
                  <Tooltip placement="top" title="Add Vendor">
                    <Button type="primary" icon={<PlusOutlined />}>
                      Add Vendor
                    </Button>
                  </Tooltip>
                </Link>
              )}
               {/* <Button type="primary" icon={<UploadOutlined  />} onClick={() => setOpenModal(true)}>
                              Import Data
                            </Button> */}
              {currentUser.permissions.permissions.vendor.includes('delete_vendor') && (
                <Tooltip placement="top" title="Archive">
                  <Link to="/archive-vendor" className="iconlink">
                    <Archiveicon style={{ cursor: 'pointer' }} />
                  </Link>
                </Tooltip>
              )}
              <Tooltip placement="top" title="Column List">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={handleDropdownVisibleChange}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </div>
      {/* <ImportDataModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        refreshTable={refreshTable}
        formatFilePath={formatFile}
        model={"vendor"}
      /> */}
      <div className='tablewrp'>
        <Table
          rowKey="id"
          dataSource={dataSource}
          columns={filteredColumns}
          // rowSelection={rowSelection}
          pagination={false} // Disable built-in pagination
          loading={status === 'loading'}
          onChange={handleTableChange}
          scroll={{ x: '1000px' }}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={["20", "50", "100"]}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />
    </div>

  );
}
